import request from '@/utils/request';

// 获取经销商账号列表
export function queryDealerAccountPageList(data) {
  return request({
    url: '/dealer/account/queryDealerAccountPageList',
    method: 'POST',
    data
  });
}
// 删除经销商账号
export function removeDealerAccountById(data) {
  return request({
    url: '/dealer/account/removeDealerAccountById',
    method: 'POST',
    data
  });
}
// 启用或禁用经销商账号
export function enableOrDisableDealerAccount(data) {
  return request({
    url: '/dealer/account/enableOrDisableDealerAccount',
    method: 'POST',
    data
  });
}
// 新增经销商账号
export function saveDealerAccount(data) {
  return request({
    url: '/dealer/account/saveDealerAccount',
    method: 'POST',
    data
  });
}
// 修改经销商账号
export function updateDealerAccount(data) {
  return request({
    url: '/dealer/account/updateDealerAccount',
    method: 'POST',
    data
  });
}
// 获取经销商账号明细
export function fetchDealerAccountDetailById(data) {
  return request({
    url: '/dealer/account/fetchDealerAccountDetailById',
    method: 'POST',
    data
  });
}
// 获取经销商订单列表
export function queryDealerOrderPageList(data) {
  return request({
    url: '/dealer/order/queryDealerOrderPageList',
    method: 'POST',
    data
  });
}
// 获取经销商订单列表-发货操作
export function sendThirdOrder(data) {
  return request({
    url: '/dealer/order/sendThirdOrder',
    method: 'POST',
    data
  });
}
// 获取一级经销商账号列表
export function queryFirstDealerAccountList(data) {
  return request({
    url: '/dealer/account/queryFirstDealerAccountList',
    method: 'POST',
    data
  });
}
// 获取经销商订单商品列表
export function queryDealerOrderGoodsPageList(data) {
  return request({
    url: '/dealerOrderGoods/queryDealerOrderGoodsPageList',
    method: 'POST',
    data
  });
}
// 订单导出Excel
export function orderExportExcel(data) {
  return request({
    url: '/dealer/order/',
    method: 'POST',
    data,
    responseType: 'blob'
  });
}



// WEBPACK FOOTER //
// ./src/api/distributor.js